import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import Creatable from 'react-select/creatable';
import {PresenterProps, withPresenter} from '../../../Support/with_presenter';
import {EditSnippetPresenter} from './EditSnippetPresenter';
import {classNames} from '../../Support/classNames';
import {SnippetCollection} from '../../../Models/SnippetCollection';
import {NetworkRequestStatusView} from '../../Components/Utils/NetworkRequestStatusView';
import {FullSnippet} from '../../../Models/Snippet';
import {Button} from '../../Components/Button';

interface OwnProps {
    snippet: FullSnippet;
    className?: string;
}

const SnippetCollectionsComponent: FunctionComponent<OwnProps & PresenterProps<EditSnippetPresenter>> = observer(
    ({className, presenter}) => {
        const description = presenter.description;

        //Keep this here to subscribe outside of the NetworkRequestStatusView
        const submitting = presenter.submitting;

        return (
            <div className={classNames('card', className)}>
                <div className="card-title">
                    <h5 className="d-flex justify-content-between align-items-baseline flex-row flex-wrap">
                        <span>Meta data</span>
                    </h5>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <NetworkRequestStatusView
                                result={presenter.me}
                                loader={() => {}}
                                error={() => {}}
                                component={(me) => {
                                    return (
                                        <>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <label htmlFor="snippetDescriptionInput">Description</label>
                                                        <textarea
                                                            id="snippetDescriptionInput"
                                                            value={description}
                                                            onChange={(e) => {
                                                                presenter.onDescriptionChange(e.target.value);
                                                            }}
                                                            className="form-control"
                                                            placeholder="Description"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 d-flex justify-content-end mt-3">
                                                    <Button
                                                        className="btn-primary"
                                                        text="Save"
                                                        loading={submitting}
                                                        onClick={() => presenter.onSubmit()}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    );
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    },
);

export const EditSnippet = withPresenter<EditSnippetPresenter, OwnProps>(
    (props, component) => new EditSnippetPresenter(props.snippet, component.network.me, component.network.snippets),
    SnippetCollectionsComponent,
);
